const DEFAULT_OTHER_COLOR = '#A0A9B8';

const defaultPlotColors = [
  '#5CA9E9',
  '#70CA97',
  '#E8A18A',
  DEFAULT_OTHER_COLOR, // historical "Other" slot — still used as fallback when no explicit otherColor is set
  '#AB99D2',
  '#D47E93',
  '#95C7F1',
  '#A2DDBB',
  '#F0C2B3',
  '#C1C7D1',
  '#C8BDE2',
  '#E3ABB9',
  '#4A87BA',
  '#5AA179',
  '#BA816E',
  '#808793',
  '#897AA8',
  '#AA6576',
];

/**
 * The active chart color palette. Mutated in-place by `setPlotColors`
 * so all existing references see updated values.
 */
export const plotColors: string[] = [...defaultPlotColors];

/**
 * The active "Other" color, used for generic/residual categories like
 * the "Other" bucket in breakdowns. Kept separate from `plotColors`
 * so it doesn't steal a slot from the ordered palette.
 */
let otherColor: string = DEFAULT_OTHER_COLOR;

/**
 * Override the chart color palette at runtime (e.g. for whitelabelling).
 * Mutates the existing `plotColors` array in-place so all consumers
 * that import it automatically see the new colors.
 */
export function setPlotColors(colors: string[]) {
  plotColors.length = 0;
  plotColors.push(...colors);
}

/** Reset chart colors back to the Revelio defaults. */
export function resetPlotColors() {
  plotColors.length = 0;
  plotColors.push(...defaultPlotColors);
}

/**
 * Override the "Other" color at runtime (e.g. for whitelabelling).
 * Decouples the generic/residual color from any specific palette index,
 * so ordered categorical bars can use the palette in order.
 */
export function setOtherColor(color: string) {
  otherColor = color;
}

/** Reset the "Other" color back to the Revelio default. */
export function resetOtherColor() {
  otherColor = DEFAULT_OTHER_COLOR;
}

export const POSITIVE_COLOR = '#70CA97';
export const NEGATIVE_COLOR = '#D47E93';

/** @deprecated Use `getPrimaryColor()` instead — this is frozen at import time. */
export const PRIMARY_COLOR = '#5CA9E9';

/** @deprecated Use `getOtherColor()` instead — this is frozen at import time. */
export const OTHER_COLOR = DEFAULT_OTHER_COLOR;

/** Returns the current first color in the active palette (updates with whitelabelling). */
export function getPrimaryColor(): string {
  return plotColors[0] ?? '#5CA9E9';
}

/** Returns the current "Other" color (updates with whitelabelling). */
export function getOtherColor(): string {
  return otherColor;
}
